export const TAGS = {
  CLASSES: "CLASSES",
  COMING_SOON: "coming soon"
};